var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ProposedTimePageType } from "@common/enums/base";
import http, { Q } from "@http";
import { observable, action, runInAction } from "mobx";
import moment from "moment";
var ProposedTimeForWOStore = /** @class */ (function () {
    function ProposedTimeForWOStore() {
        var _this = this;
        this.currentPage = ProposedTimePageType.NotSubmitted;
        this.isRecommendScheduleTimeLoading = false;
        this.isAssignee = false;
        this.timesList = [];
        this.serviceComboModal = {
            woId: '',
            serviceCodeIconUrl: '',
            serviceCategoryAliasName: '',
            serviceTypeAliasName: '',
            serviceCodeAliasName: ''
        };
        this.otherResidentList = [];
        this.woDetail = {};
        this.reason = '';
        this.getQueryValue = function (queryName) {
            var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", 'i');
            var r = window.location.href.substring(window.location.href.indexOf('?') + 1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        };
        this.getWoDetail = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getWoDetail(this.woId)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (data) {
                                _this.woDetail = data;
                            }
                        });
                        return [2 /*return*/, data || {}];
                }
            });
        }); };
        var woId = this.getQueryValue('woId') || null;
        this.woId = woId;
    }
    ProposedTimeForWOStore.prototype.setParam = function (key, value) {
        var _a;
        Object.assign(this, (_a = {}, _a[key] = value, _a));
    };
    ProposedTimeForWOStore.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getWoServiceComboAliasByWoId()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getLocationOtherResidents()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getAffiliateRecommendScheduleTimes()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.getWoServiceComboAliasByWoId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecommendScheduleTimeLoading = true;
                        return [4 /*yield*/, this.api().getWoServiceComboAliasByWoId()];
                    case 1:
                        promise = _a.sent();
                        runInAction(function () {
                            if (promise) {
                                _this.serviceComboModal = promise;
                            }
                            _this.isRecommendScheduleTimeLoading = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.getAffiliateRecommendScheduleTimes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecommendScheduleTimeLoading = true;
                        return [4 /*yield*/, this.api().getAffiliateRecommendScheduleTimes()];
                    case 1:
                        promise = _a.sent();
                        runInAction(function () {
                            if (promise) {
                                _this.isAssignee = promise.isAssignee;
                                _this.timesList = promise.recommendScheduleTimes && promise.recommendScheduleTimes.map(function (e) {
                                    return {
                                        id: e.id.toString(),
                                        currentDate: "" + moment(e.startTime).format('dddd, MMMM Do'),
                                        startTime: e.startTime,
                                        endTime: e.endTime,
                                        isSelected: e.isSelected
                                    };
                                });
                            }
                            _this.isRecommendScheduleTimeLoading = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.saveSelectedAffiliateRecommendScheduleTime = function (selectedIds) {
        return __awaiter(this, void 0, void 0, function () {
            var currentSelectedTimes, postData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecommendScheduleTimeLoading = true;
                        currentSelectedTimes = this.timesList.filter(function (x) { return selectedIds.indexOf(x.id) > -1; }).map(function (e) {
                            return {
                                startTime: e.startTime,
                                endTime: e.endTime,
                            };
                        });
                        postData = {
                            woReactiveId: this.woId,
                            selectedRecommendScheduleTimes: currentSelectedTimes
                        };
                        return [4 /*yield*/, this.api().saveSelectedAffiliateRecommendScheduleTime(postData)];
                    case 1:
                        _a.sent();
                        runInAction(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getAffiliateRecommendScheduleTimes()];
                                    case 1:
                                        _a.sent();
                                        this.isRecommendScheduleTimeLoading = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.getLocationOtherResidents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecommendScheduleTimeLoading = true;
                        return [4 /*yield*/, this.api().getLocationOtherResidents()];
                    case 1:
                        promise = _a.sent();
                        runInAction(function () {
                            if (promise) {
                                _this.otherResidentList = promise;
                                _this.isRecommendScheduleTimeLoading = false;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.updateAssignedUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var postData, promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecommendScheduleTimeLoading = true;
                        postData = {
                            reactiveWoId: this.woId,
                            userId: this.selectResidentId
                        };
                        return [4 /*yield*/, this.api().updateAssignedUser(postData)];
                    case 1:
                        promise = _a.sent();
                        runInAction(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!promise) return [3 /*break*/, 2];
                                        this.currentPage = ProposedTimePageType.NotSubmitted;
                                        return [4 /*yield*/, this.getAffiliateRecommendScheduleTimes()];
                                    case 1:
                                        _a.sent();
                                        this.isRecommendScheduleTimeLoading = false;
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.declinedAffiliateRecommendScheduleTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var postData, promise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecommendScheduleTimeLoading = true;
                        postData = {
                            reactiveWoId: this.woId,
                            note: this.reason
                        };
                        return [4 /*yield*/, this.api().declinedAffiliateRecommendScheduleTime(postData)];
                    case 1:
                        promise = _a.sent();
                        runInAction(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!promise) return [3 /*break*/, 2];
                                        this.currentPage = ProposedTimePageType.NotSubmitted;
                                        return [4 /*yield*/, this.getAffiliateRecommendScheduleTimes()];
                                    case 1:
                                        _a.sent();
                                        this.isRecommendScheduleTimeLoading = false;
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProposedTimeForWOStore.prototype.api = function () {
        var _this = this;
        return {
            getAffiliateRecommendScheduleTimes: function () {
                return Q(http.get("TaskManager/GetAffiliateRecommendScheduleTimes?reactiveWoId=" + _this.woId));
            },
            getWoServiceComboAliasByWoId: function () {
                return Q(http.get("TaskManager/GetWoServiceComboAliasByWoId?reactiveWoId=" + _this.woId));
            },
            saveSelectedAffiliateRecommendScheduleTime: function (postData) {
                return Q(http.post('TaskManager/SaveSelectedAffiliateRecommendScheduleTime', postData));
            },
            getLocationOtherResidents: function () {
                return Q(http.get("TaskManager/GetLocationOtherResidents?reactiveWoId=" + _this.woId));
            },
            updateAssignedUser: function (postData) {
                return Q(http.post('TaskManager/UpdateAssignedUser', postData));
            },
            declinedAffiliateRecommendScheduleTime: function (postData) {
                return Q(http.post('TaskManager/DeclinedAffiliateRecommendScheduleTime', postData));
            },
            getWoDetail: function (woId) {
                return Q(http.post("/RSP/Request/" + woId + "/WoDetail"));
            },
        };
    };
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "currentPage", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "isRecommendScheduleTimeLoading", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "woId", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "isAssignee", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "timesList", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "serviceComboModal", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "otherResidentList", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "selectResidentId", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "woDetail", void 0);
    __decorate([
        observable
    ], ProposedTimeForWOStore.prototype, "reason", void 0);
    __decorate([
        action.bound
    ], ProposedTimeForWOStore.prototype, "setParam", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "getQueryValue", void 0);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "init", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "getWoServiceComboAliasByWoId", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "getAffiliateRecommendScheduleTimes", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "saveSelectedAffiliateRecommendScheduleTime", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "getLocationOtherResidents", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "updateAssignedUser", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "declinedAffiliateRecommendScheduleTime", null);
    __decorate([
        action
    ], ProposedTimeForWOStore.prototype, "getWoDetail", void 0);
    return ProposedTimeForWOStore;
}());
export default ProposedTimeForWOStore;
